module.exports = __webpack_public_path__ + "img/26D4.3be2abac.svg";